import { createRouter, createWebHashHistory } from 'vue-router'

// 账号相关组件
const IndexView = () =>
    import ("@/views/indexView");
// 项目案例
const Case = () =>
    import ("@/components/Case/Case.vue")
const home= () =>
    import ("@/components/Home/Home.vue")
const AboutUs= () =>
    import ("@/components/AboutUs/AboutUs.vue")
const contactUs= () =>
    import ("@/components/contactUs/contactUs.vue")
const CoreServices= () =>
    import ("@/components/CoreServices/CoreServices.vue")
const DownloadPage= () =>
    import ("@/components/Download/DownloadPage.vue")
const routes = [{
        path: '/',
        component: IndexView,
        redirect: '/home',
        meta: {
            // title: '首页',
            name: 'index',
            requiresAuth: true
        },
        children: [
            {
                path: 'CoreServices',
                component: CoreServices,
                meta: {
                    // title: '核心服务',
                    requiresAuth: true
                }
            },
            {
                path: 'contactUs',
                component: contactUs,
                meta: {
                    title: '联系我们',
                    requiresAuth: true
                }
            },
            {
                path: 'case',
                component: Case,
                meta: {
                    title: '项目案例',
                    requiresAuth: true
                }
            },
            {
                path: 'AboutUs',
                component: AboutUs,
                meta: {
                    title: '关于我们',
                    requiresAuth: true
                }
            },
            {
                path: 'home',
                component: home,
                meta: {
                    title: '首页',
                    requiresAuth: true
                }
            },
            {
                path: 'DownloadPage',
                component: DownloadPage,
                meta: {
                    title: '下载',
                    requiresAuth: true
                }
            },
        ]
    },
]

export const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})